module.exports = __webpack_public_path__ + "img/pog_maelstrom.44c59a19.png";